import React, { useEffect, useState } from "react";
import Popover from "@mui/material/Popover";
import FocusTags from "../FocusTags/FocusTags";
import classes from "./PopoverTrigger.module.css";
import { CheckBoxAndRadioWithSearch } from "../CheckBoxAndRadioWithSearch/CheckBoxAndRadioWithSearch";
import { AveragePriceRangePicker } from "../AveragePriceRangePicker/AveragePriceRangePicker";
import { DistanceRangePicker } from "../DistanceRangePicker/DistanceRangePicker";
import { TimeOfTheDay } from "../TimeOfTheDay/TimeOfTheDay";
import { CheckboxAndRadioMenu } from "../CheckboxAndRadioMenu/CheckboxAndRadioMenu.jsx";

export default function BasicPopover({
  handleClick,
  handleClose,
  open,
  btnText,
  anchorEl,
  minAndMaxPrice,
  setMinAndMaxPrice,
  value,
  setValue,
  options,
  checkBoxTitle,
  setCheckBoxTitle,
  radioBtnData,
  setRadioBtnData,
  Specialties,
  handlePriceRange,
  handleDistanceRange,
  onSaveHandler
}) {
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTimings, setSelectedTimings] = useState([]);
  // const [checkBoxTitle, setCheckboxTitle] = useState([]);
  console.log(checkBoxTitle);



  console.log(minAndMaxPrice);
  return (
    <>
      <style>
        {`.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8{
            border-radius:10px;
            margin-top:8px
        }
        `}
      </style>
      <div>
        <Popover
          className={classes.main}
          // style={{ marginTop: "20px", borderRadius: "10px" }}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          {btnText == "My filters" && <FocusTags />}
          {btnText == "Focus tags" && (
            <CheckBoxAndRadioWithSearch isSearch={true} />
          )}
          {btnText?.split(" ")[0] == "Price" && (
            <AveragePriceRangePicker
              setMinAndMaxPrice={setMinAndMaxPrice}
              minAndMaxPrice={minAndMaxPrice}
              handlePriceRange={handlePriceRange}
            />
          )}
          {btnText?.split(" ")[0] == "Distance" && (
            <DistanceRangePicker
              handleDistanceRange={handleDistanceRange}
              value={value}
              setValue={setValue}
            />
          )}
          {btnText == "Schedule" && (
            <TimeOfTheDay
              selectedDays={selectedDays}
              setSelectedDays={setSelectedDays}
              selectedTimings={selectedTimings}
              setSelectedTimings={setSelectedTimings}
            />
          )}
          {btnText == radioBtnData[0] && (
            <CheckboxAndRadioMenu
              setRadioBtnData={setRadioBtnData}
              value={checkBoxTitle}
              setValue={setCheckBoxTitle}
              options={options}
              type={"radio"}
              onSaveHandler={onSaveHandler}
            />
          )}
          {btnText == "Specialties" && (
            <CheckboxAndRadioMenu
              setRadioBtnData={setRadioBtnData}
              value={checkBoxTitle}
              setValue={setCheckBoxTitle}
              // options={Specialties}
              type={"Checkbox"}
            />
          )}
        </Popover>
      </div>
    </>
  );
}
